import { Brand } from '../components/Brand.js';
import { RouteMethodNote } from '../components/RouteMethodNote.js';

export function RouteMethodologyPage() {
  return (
    <div className="intent-page retro-landing">
      <header className="site-header wrap">
        <a href="/" aria-label="Bikepacking Live home">
          <Brand linked={false} />
        </a>
        <nav aria-label="Main navigation">
          <a href="/">Overview</a>
          <a href="/#playground">Live demo</a>
          <a href="/#pricing">Pricing</a>
        </nav>
        <div className="header-actions">
          <a href="/signin">Sign in</a>
          <a className="button button--small" href="/start">
            Create free account
          </a>
        </div>
      </header>
      <main>
        <section className="methodology-hero wrap">
          <p className="eyebrow">Route example methodology</p>
          <h1>How the example routes were made.</h1>
          <p className="lede">
            The landing-page routes are reproducible product examples. They show how Bikepacking
            Live stores and presents a real bicycle route; they are not endorsements, trail guides,
            or promises that conditions remain unchanged.
          </p>
        </section>
        <section className="methodology-grid wrap">
          <article>
            <span>01</span>
            <h2>Generated in production</h2>
            <p>
              Each line was returned by the production Valhalla 3.7 bicycle-routing engine running
              on Bikepacking Live infrastructure. Coordinates were simplified to roughly 20 metres
              for a lighter page while preserving the route shape.
            </p>
          </article>
          <article>
            <span>02</span>
            <h2>Checked as an example</h2>
            <p>
              Ahmed checked the named endpoints, coordinate continuity, stage joins, and displayed
              distances on 26 August 2026. The current Via Claudia engine total is 242.5 km, which
              also matches the sum of its independently rounded daily labels.
            </p>
          </article>
          <article>
            <span>03</span>
            <h2>Review before riding</h2>
            <p>
              Routing cannot guarantee legal access, a preferred surface, open ferries, safe
              weather, or current closures. Check authoritative local sources and carry navigation
              you trust before using any generated route outdoors.
            </p>
          </article>
        </section>
        <section className="wrap methodology-example">
          <RouteMethodNote />
        </section>
        <section className="intent-cta">
          <div className="wrap">
            <p className="eyebrow">Start with your own endpoints</p>
            <h2>Build the trip. Check every stage.</h2>
            <p>Private planning is free. Publish a follower link only when it is useful.</p>
            <div className="button-row">
              <a className="button button--light" href="/start">
                Create your free account
              </a>
              <a className="button button--outline-light" href="/bikepacking-trip-planner/">
                See the planning example
              </a>
            </div>
          </div>
        </section>
      </main>
      <footer className="site-footer wrap">
        <Brand linked={false} />
        <p>Plan the long way around. Share it live when you want.</p>
        <nav>
          <a href="/">Overview</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </nav>
      </footer>
    </div>
  );
}
